"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcAvatarBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_avatar_constants_1 = require("./bc-avatar-constants");
var bc_avatar_constants_2 = require("./bc-avatar-constants");
var bc_avatar_constants_3 = require("./bc-avatar-constants");
var BcAvatarBehavior = (function (_super) {
    __extends(BcAvatarBehavior, _super);
    function BcAvatarBehavior() {
        var _this = _super.call(this) || this;
        _this.iconSize = {
            tiny: 'bc-2xs',
            small: 'bc-sm',
            medium: 'bc-md',
            large: 'bc-xl',
            xlarge: 'bc-3xl',
        };
        _this.handleImageLoad = _this.handleImageLoad.bind(_this);
        return _this;
    }
    BcAvatarBehavior.setUpAll = function () {
        var imgElements = Array.from(document.querySelectorAll("[class^='".concat(bc_avatar_constants_1.BC_AVATAR_CLASS, "']")));
        var elements = [];
        for (var _i = 0, imgElements_1 = imgElements; _i < imgElements_1.length; _i++) {
            var imgElement = imgElements_1[_i];
            var element = imgElement;
            var bc = new BcAvatarBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcAvatarBehavior.prototype._setUp = function () {
        this.buildAvatar();
        this.setupFocus();
        this.setupTooltip();
    };
    BcAvatarBehavior.prototype.setupFocus = function () {
        var focus = this.mySelf.getAttribute('focus');
        if (focus && focus === 'true') {
            this.mySelf.setAttribute('tabindex', '0');
            this.mySelf.setAttribute('role', 'button');
        }
    };
    BcAvatarBehavior.prototype.setupTooltip = function () {
        var tooltipText = this.mySelf.getAttribute('tooltip');
        if (tooltipText) {
            this.setupTooltipAttributes(this.mySelf, tooltipText);
        }
    };
    BcAvatarBehavior.prototype.buildAvatar = function () {
        var isImgTag = this.mySelf.outerHTML.includes('img');
        if (isImgTag) {
            this.setupImgTag();
        }
        else {
            this.setupIconType();
        }
    };
    BcAvatarBehavior.prototype.setupTooltipAttributes = function (element, tooltipText) {
        element.setAttribute('bctooltipposition', 'bottom');
        element.setAttribute('bctooltiptext', tooltipText);
        element.classList.add('bc-tooltip');
    };
    BcAvatarBehavior.prototype.handleImageLoad = function () {
        this.mySelf.classList.remove('bc-avatar-loading');
    };
    BcAvatarBehavior.prototype.setupImgTag = function () {
        this.mySelf.classList.add('bc-avatar-loading');
        if (this.mySelf.complete) {
            this.mySelf.classList.remove('bc-avatar-loading');
        }
        else {
            this.mySelf.addEventListener('load', this.handleImageLoad);
        }
        var srcAvatar = this.mySelf.getAttribute('src');
        if (!srcAvatar) {
            this.mySelf.setAttribute('src', bc_avatar_constants_1.BC_AVATAR_SVG_DEFAULT);
            this.mySelf.classList.add(bc_avatar_constants_1.BC_AVATAR_NULL_SRC);
        }
    };
    BcAvatarBehavior.prototype.getIcon = function (icon, size) {
        var bcIcon = document.createElement('i');
        bcIcon.classList.add('bc-icon', size);
        bcIcon.setAttribute('role', 'img');
        bcIcon.setAttribute('aria-hidden', 'true');
        bcIcon.textContent = icon;
        return bcIcon;
    };
    BcAvatarBehavior.prototype.validateSize = function (avatarSize) {
        if (['tiny', 'small', 'medium', 'large', 'xlarge'].includes(avatarSize)) {
            return avatarSize;
        }
        return 'tiny';
    };
    BcAvatarBehavior.prototype.createIllustration = function () {
        var illustrationName = this.mySelf.getAttribute('illustration') || 'il-setting-wallet';
        var publicDirectory = this.mySelf.getAttribute('public') === 'false' ? '' : bc_avatar_constants_3.BC_AVATAR_ILLUSTRATION_DIRECTORY_PUBLIC;
        var altText = this.mySelf.getAttribute('alt') || illustrationName;
        var illustrationElement = document.createElement('img');
        illustrationElement.setAttribute('src', "".concat(publicDirectory).concat(bc_avatar_constants_2.BC_AVATAR_ILLUSTRATION_DIRECTORY).concat(illustrationName, ".svg"));
        illustrationElement.setAttribute('alt', altText);
        illustrationElement.setAttribute('aria-hidden', 'true');
        this.mySelf.append(illustrationElement);
        this.mySelf.classList.add('bc-avatar-illustration');
    };
    BcAvatarBehavior.prototype.createIcon = function (avatarSize) {
        var iconName = this.mySelf.getAttribute('icon') || 'user';
        var icon = this.getIcon(iconName, this.iconSize[avatarSize]);
        this.mySelf.classList.add('bc-avatar-icon');
        this.mySelf.append(icon);
    };
    BcAvatarBehavior.prototype.setupIconType = function () {
        var isDivTag = this.mySelf.outerHTML.includes('div');
        if (isDivTag) {
            var avatarSize = this.validateSize(this.mySelf.getAttribute('size'));
            var avatarSizeClass = 'bc-avatar-' + avatarSize;
            this.mySelf.classList.add(avatarSizeClass);
            if (this.mySelf.hasAttribute('illustration')) {
                this.createIllustration();
            }
            else {
                this.createIcon(avatarSize);
            }
        }
    };
    return BcAvatarBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcAvatarBehavior = BcAvatarBehavior;
